import { useSelector } from 'react-redux';
import { IdeaState } from '@/reducers/idea';

export default function useIdeaList() {
  const ideaList = useSelector((state: { idea: IdeaState }) => state.idea.ideaList);

  return ideaList;
}
